export default __webpack_public_path__ + "static/media/TotalOP.0205487c.svg";